var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 480,
    viewBox: "0 0 575 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470.092 465.103L366.312 438.5H464.281L570.427 465.103H470.092Z",
    fill: "#FFD7A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.335 465.103L204.114 438.5H106.16L0 465.103H100.335Z",
    fill: "#FFD7A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.994 354.433C289.994 354.433 289.896 353.943 289.742 353.033",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M289.284 350.289C287.786 340.586 285.252 316.378 294.759 305.568C306.814 291.889 321.264 303.608 361.532 305.568C401.8 307.529 422.523 301.662 422.943 267.134C423.363 232.606 399.742 230.324 399.742 230.324H384.817",
    stroke: "#2E353A",
    strokeMiterlimit: 10,
    strokeDasharray: "2.01 2.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.396 230.381H381.996",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M381.996 124.318H383.396",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M386.199 124.318H436.605C436.605 124.318 451.796 125.635 451.166 143.164C450.536 160.694 425.263 177.118 426.874 212.122C428.484 247.126 488.214 241.903 496.349 276.949C504.484 311.995 444.726 310.245 439.167 328.334C437.42 332.39 436.56 336.773 436.647 341.188C436.647 347.068 436.647 361.042 436.647 367.021",
    stroke: "#2E353A",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M436.648 368.436V369.836",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.451 25.1035H195.051",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.267 25.1041H167.582C167.582 25.1041 100.375 24.334 100.375 81.1101C100.375 107.391 109.504 127.035 136.555 159.323C163.606 191.61 163.158 292.533 154.365 310.637C145.572 328.741 126.922 326.039 120.369 335.84C120.369 335.84 115.651 340.782 115.245 346.817C114.923 351.563 115.105 367.119 115.245 373.504",
    stroke: "#2E353A",
    strokeMiterlimit: 10,
    strokeDasharray: "1.99 1.99"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.176 374.975C115.176 375.857 115.176 376.375 115.176 376.375",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211.559 98.2063C208.534 98.2108 205.564 99.0125 202.948 100.531C203.19 99.1859 203.312 97.8224 203.312 96.4561C203.317 90.5222 201.105 84.8006 197.11 80.4128C193.115 76.0251 187.626 73.2878 181.717 72.7374C175.809 72.1871 169.908 73.8634 165.172 77.4379C160.435 81.0123 157.205 86.227 156.113 92.0597C153.24 91.0111 150.173 90.6026 147.126 90.8628C144.078 91.123 141.125 92.0456 138.471 93.566C135.818 95.0865 133.528 97.1681 131.763 99.6655C129.997 102.163 128.798 105.016 128.25 108.024C127.702 111.033 127.818 114.125 128.589 117.085C129.36 120.044 130.768 122.8 132.715 125.158C134.662 127.517 137.101 129.422 139.86 130.74C142.62 132.058 145.634 132.758 148.692 132.79H211.573C216.159 132.79 220.558 130.968 223.8 127.725C227.043 124.483 228.865 120.084 228.865 115.498C228.865 110.912 227.043 106.514 223.8 103.271C220.558 100.028 216.159 98.2063 211.573 98.2063H211.559Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M477.377 168.465C474.152 168.467 470.984 169.317 468.192 170.929C468.439 169.5 468.565 168.053 468.57 166.603C468.571 160.287 466.215 154.198 461.961 149.529C457.708 144.861 451.864 141.948 445.575 141.363C439.287 140.778 433.006 142.562 427.964 146.366C422.922 150.169 419.482 155.719 418.318 161.926C415.251 160.788 411.97 160.335 408.709 160.6C405.447 160.865 402.283 161.842 399.44 163.461C396.596 165.08 394.141 167.302 392.249 169.972C390.356 172.641 389.071 175.693 388.484 178.912C387.897 182.131 388.023 185.44 388.852 188.606C389.681 191.771 391.194 194.717 393.284 197.235C395.374 199.753 397.99 201.783 400.948 203.182C403.906 204.581 407.135 205.314 410.408 205.331H477.377C482.26 205.331 486.943 203.391 490.396 199.938C493.849 196.485 495.789 191.802 495.789 186.919C495.789 182.036 493.849 177.353 490.396 173.9C486.943 170.447 482.26 168.507 477.377 168.507V168.465Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M465.477 210.021H471.077",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M438.176 210.021H457.778",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M419.637 142.38C422.503 139.971 426.043 138.504 429.774 138.18",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M412.973 152.615C413.477 150.401 414.43 148.314 415.773 146.482",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200.357 253.707C195.509 253.71 190.747 254.99 186.551 257.417C186.935 255.268 187.127 253.089 187.125 250.906C187.132 241.413 183.592 232.26 177.199 225.242C170.807 218.224 162.023 213.848 152.57 212.971C143.118 212.095 133.679 214.781 126.105 220.504C118.531 226.227 113.368 234.573 111.629 243.906C107.031 242.218 102.119 241.557 97.2382 241.967C92.3573 242.377 87.6251 243.849 83.373 246.281C79.1208 248.712 75.4516 252.044 72.6223 256.042C69.793 260.04 67.872 264.609 66.9938 269.427C66.1155 274.246 66.3014 279.199 67.5383 283.938C68.7752 288.677 71.0332 293.089 74.1542 296.864C77.2752 300.639 81.1838 303.686 85.6062 305.792C90.0286 307.898 94.8578 309.011 99.7558 309.055H200.357C207.585 308.892 214.462 305.907 219.517 300.737C224.571 295.567 227.401 288.625 227.401 281.395C227.401 274.165 224.571 267.222 219.517 262.053C214.462 256.883 207.585 253.897 200.357 253.735V253.707Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9258 306.24C75.3344 307.175 76.8084 308.008 78.3363 308.733",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9336 293.332C64.2746 296.521 66.2245 299.417 68.6742 301.859",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M125.004 210.723C130.82 206.721 137.794 204.752 144.844 205.122",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.938 216.322C119.913 215.047 121.021 213.879 122.242 212.836",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M382.01 116.576H375.359V134.162H382.01V116.576Z",
    fill: "#233F53",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M382.01 220.314H375.359V237.9H382.01V220.314Z",
    fill: "#233F53",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M203.112 14.8281H196.461V32.414H203.112V14.8281Z",
    fill: "#233F53",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M203.112 169.109H196.461V186.695H203.112V169.109Z",
    fill: "#233F53",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M377.549 5.0957H202.488V43.0118H377.549V5.0957Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M331.55 14.7715H210.898V33.3375H331.55V14.7715Z",
    fill: "#FFD7A1",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M347.891 27.9194C350.474 27.9194 352.568 25.8257 352.568 23.2429C352.568 20.6601 350.474 18.5664 347.891 18.5664C345.309 18.5664 343.215 20.6601 343.215 23.2429C343.215 25.8257 345.309 27.9194 347.891 27.9194Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M370.892 23.2429C370.892 22.318 370.618 21.4138 370.104 20.6448C369.59 19.8757 368.86 19.2763 368.005 18.9224C367.151 18.5684 366.21 18.4758 365.303 18.6563C364.396 18.8367 363.563 19.2821 362.909 19.9361C362.255 20.5901 361.809 21.4234 361.629 22.3306C361.448 23.2377 361.541 24.178 361.895 25.0325C362.249 25.8871 362.848 26.6174 363.617 27.1313C364.386 27.6451 365.291 27.9194 366.216 27.9194C367.456 27.9194 368.645 27.4267 369.522 26.5497C370.399 25.6727 370.892 24.4832 370.892 23.2429Z",
    fill: "#C84040",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M320.598 27.9194C323.181 27.9194 325.275 25.8257 325.275 23.2429C325.275 20.6601 323.181 18.5664 320.598 18.5664C318.016 18.5664 315.922 20.6601 315.922 23.2429C315.922 25.8257 318.016 27.9194 320.598 27.9194Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M370.906 43.0117H209.133V55.9911H370.906V43.0117Z",
    fill: "#233F53",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M377.549 55.9922H202.488V93.9083H377.549V55.9922Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M331.55 65.668H210.898V84.234H331.55V65.668Z",
    fill: "#FFD7A1",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M347.891 78.8276C350.474 78.8276 352.568 76.7339 352.568 74.1511C352.568 71.5684 350.474 69.4746 347.891 69.4746C345.309 69.4746 343.215 71.5684 343.215 74.1511C343.215 76.7339 345.309 78.8276 347.891 78.8276Z",
    fill: "#C84040",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M370.892 74.1511C370.892 73.2262 370.618 72.322 370.104 71.553C369.59 70.7839 368.86 70.1845 368.005 69.8306C367.151 69.4766 366.21 69.384 365.303 69.5645C364.396 69.7449 363.563 70.1903 362.909 70.8443C362.255 71.4984 361.809 72.3316 361.629 73.2388C361.448 74.1459 361.541 75.0862 361.895 75.9407C362.249 76.7953 362.848 77.5256 363.617 78.0395C364.386 78.5534 365.291 78.8276 366.216 78.8276C366.83 78.8295 367.439 78.7098 368.007 78.4754C368.576 78.2411 369.092 77.8966 369.526 77.462C369.961 77.0274 370.305 76.5111 370.54 75.9429C370.774 75.3747 370.894 74.7658 370.892 74.1511Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M320.598 78.8276C323.181 78.8276 325.275 76.7339 325.275 74.1511C325.275 71.5684 323.181 69.4746 320.598 69.4746C318.016 69.4746 315.922 71.5684 315.922 74.1511C315.922 76.7339 318.016 78.8276 320.598 78.8276Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M370.906 93.9219H209.133V106.901H370.906V93.9219Z",
    fill: "#233F53",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M377.549 106.902H202.488V144.818H377.549V106.902Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M331.55 116.576H210.898V135.142H331.55V116.576Z",
    fill: "#FFD7A1",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M347.891 129.724C350.474 129.724 352.568 127.63 352.568 125.048C352.568 122.465 350.474 120.371 347.891 120.371C345.309 120.371 343.215 122.465 343.215 125.048C343.215 127.63 345.309 129.724 347.891 129.724Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M370.892 125.048C370.892 124.123 370.618 123.219 370.104 122.449C369.59 121.68 368.86 121.081 368.005 120.727C367.151 120.373 366.21 120.281 365.303 120.461C364.396 120.641 363.563 121.087 362.909 121.741C362.255 122.395 361.809 123.228 361.629 124.135C361.448 125.042 361.541 125.983 361.895 126.837C362.249 127.692 362.848 128.422 363.617 128.936C364.386 129.45 365.291 129.724 366.216 129.724C367.456 129.724 368.645 129.231 369.522 128.354C370.399 127.477 370.892 126.288 370.892 125.048Z",
    fill: "#C84040",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M320.598 129.724C323.181 129.724 325.275 127.63 325.275 125.048C325.275 122.465 323.181 120.371 320.598 120.371C318.016 120.371 315.922 122.465 315.922 125.048C315.922 127.63 318.016 129.724 320.598 129.724Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M370.906 144.818H209.133V157.798H370.906V144.818Z",
    fill: "#233F53",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M377.549 157.797H202.488V195.713H377.549V157.797Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M331.55 167.473H210.898V186.039H331.55V167.473Z",
    fill: "#FFD7A1",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M347.891 180.634C350.474 180.634 352.568 178.541 352.568 175.958C352.568 173.375 350.474 171.281 347.891 171.281C345.309 171.281 343.215 173.375 343.215 175.958C343.215 178.541 345.309 180.634 347.891 180.634Z",
    fill: "#C84040",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M370.892 175.958C370.892 175.033 370.618 174.129 370.104 173.36C369.59 172.591 368.86 171.991 368.005 171.637C367.151 171.283 366.21 171.191 365.303 171.371C364.396 171.552 363.563 171.997 362.909 172.651C362.255 173.305 361.809 174.138 361.629 175.045C361.448 175.953 361.541 176.893 361.895 177.747C362.249 178.602 362.848 179.332 363.617 179.846C364.386 180.36 365.291 180.634 366.216 180.634C366.83 180.636 367.439 180.516 368.007 180.282C368.576 180.048 369.092 179.703 369.526 179.269C369.961 178.834 370.305 178.318 370.54 177.75C370.774 177.181 370.894 176.572 370.892 175.958Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M320.598 180.634C323.181 180.634 325.275 178.541 325.275 175.958C325.275 173.375 323.181 171.281 320.598 171.281C318.016 171.281 315.922 173.375 315.922 175.958C315.922 178.541 318.016 180.634 320.598 180.634Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M370.906 195.727H209.133V208.706H370.906V195.727Z",
    fill: "#233F53",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M377.549 208.707H202.488V246.623H377.549V208.707Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M331.55 218.381H210.898V236.947H331.55V218.381Z",
    fill: "#FFD7A1",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M347.891 231.529C350.474 231.529 352.568 229.435 352.568 226.852C352.568 224.27 350.474 222.176 347.891 222.176C345.309 222.176 343.215 224.27 343.215 226.852C343.215 229.435 345.309 231.529 347.891 231.529Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M370.892 226.852C370.892 225.927 370.618 225.023 370.104 224.254C369.59 223.485 368.86 222.886 368.005 222.532C367.151 222.178 366.21 222.085 365.303 222.266C364.396 222.446 363.563 222.891 362.909 223.546C362.255 224.2 361.809 225.033 361.629 225.94C361.448 226.847 361.541 227.787 361.895 228.642C362.249 229.496 362.848 230.227 363.617 230.741C364.386 231.255 365.291 231.529 366.216 231.529C367.456 231.529 368.645 231.036 369.522 230.159C370.399 229.282 370.892 228.093 370.892 226.852Z",
    fill: "#C84040",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M320.598 231.529C323.181 231.529 325.275 229.435 325.275 226.852C325.275 224.27 323.181 222.176 320.598 222.176C318.016 222.176 315.922 224.27 315.922 226.852C315.922 229.435 318.016 231.529 320.598 231.529Z",
    fill: "white",
    stroke: "#233F53",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M301.668 0H311.469",
    stroke: "#233F53",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M233.762 0H290.468",
    stroke: "#233F53",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M195.258 230.324V237.325",
    stroke: "#233F53",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M195.258 208.623V223.325",
    stroke: "#233F53",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M453.453 79.2354L443.652 59.8433C443.597 59.7078 443.514 59.5852 443.41 59.483C443.305 59.3808 443.181 59.3012 443.044 59.2492C442.907 59.1973 442.762 59.174 442.616 59.1809C442.47 59.1877 442.327 59.2246 442.195 59.2892C442.064 59.3538 441.948 59.4448 441.853 59.5563C441.759 59.6679 441.689 59.7978 441.647 59.9378C441.604 60.0778 441.592 60.2249 441.609 60.3701C441.626 60.5152 441.673 60.6552 441.747 60.7814L451.114 80.3835C450.922 80.5815 450.789 80.8292 450.729 81.0988C450.67 81.3684 450.687 81.6492 450.778 81.9097L460.691 100.49C460.957 101.022 461.798 101.134 462.596 100.742C463.394 100.35 463.814 99.6076 463.548 99.0895L454.867 79.8934C454.723 79.6558 454.512 79.4664 454.26 79.3492C454.008 79.2321 453.727 79.1924 453.453 79.2354Z",
    fill: "#2E353A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M507.725 79.2356L517.596 59.8435C517.717 59.5931 517.933 59.4008 518.195 59.309C518.458 59.2171 518.746 59.2331 518.997 59.3535C519.242 59.4798 519.43 59.6954 519.521 59.9559C519.612 60.2163 519.6 60.5018 519.487 60.7536L510.106 80.3557C510.302 80.5511 510.437 80.8004 510.491 81.072C510.546 81.3437 510.519 81.6256 510.414 81.8819L500.501 100.462C500.235 100.994 499.38 101.106 498.596 100.714C497.812 100.322 497.378 99.5798 497.63 99.0618L506.325 79.8657C506.472 79.6357 506.682 79.4535 506.931 79.3416C507.18 79.2297 507.456 79.1928 507.725 79.2356Z",
    fill: "#2E353A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M511.475 101.329H449.91L454.531 93.4883H506.854L511.475 101.329Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M511.461 101.33H449.91V109.171H511.461V101.33Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M479.623 106.986H455.96C455.502 106.982 455.064 106.797 454.742 106.472C454.419 106.147 454.238 105.708 454.238 105.25C454.238 104.793 454.42 104.355 454.743 104.032C455.066 103.709 455.504 103.527 455.96 103.527H479.623C480.08 103.527 480.518 103.709 480.841 104.032C481.164 104.355 481.345 104.793 481.345 105.25C481.345 105.708 481.164 106.147 480.842 106.472C480.519 106.797 480.081 106.982 479.623 106.986Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M493.942 106.552C494.777 106.552 495.454 105.875 495.454 105.04C495.454 104.204 494.777 103.527 493.942 103.527C493.107 103.527 492.43 104.204 492.43 105.04C492.43 105.875 493.107 106.552 493.942 106.552Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M501.732 105.04C501.732 104.738 501.642 104.443 501.475 104.192C501.307 103.941 501.069 103.745 500.79 103.63C500.511 103.514 500.204 103.484 499.908 103.543C499.612 103.602 499.34 103.747 499.127 103.961C498.913 104.174 498.768 104.446 498.709 104.742C498.65 105.038 498.68 105.345 498.796 105.624C498.911 105.903 499.107 106.141 499.358 106.309C499.609 106.476 499.904 106.566 500.206 106.566C500.407 106.568 500.606 106.53 500.792 106.454C500.978 106.378 501.147 106.265 501.289 106.123C501.431 105.981 501.544 105.812 501.62 105.626C501.696 105.44 501.734 105.241 501.732 105.04Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M506.473 106.552C507.308 106.552 507.985 105.875 507.985 105.04C507.985 104.204 507.308 103.527 506.473 103.527C505.638 103.527 504.961 104.204 504.961 105.04C504.961 105.875 505.638 106.552 506.473 106.552Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M532.98 57.2383C533.179 58.201 533.277 59.1817 533.275 60.1646C533.275 60.2906 533.275 60.4026 533.275 60.5286",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M510.746 47.9972C512.553 46.8076 514.604 46.0366 516.747 45.7404C518.89 45.4441 521.072 45.6302 523.135 46.285C525.197 46.9397 527.087 48.0466 528.667 49.525C530.247 51.0033 531.476 52.8157 532.266 54.8299",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M514.81 50.1113C514.029 50.4162 513.287 50.8109 512.598 51.2875",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M529.491 60.4305C529.498 60.342 529.498 60.253 529.491 60.1645C529.491 57.3014 528.354 54.5556 526.329 52.5311C524.305 50.5066 521.559 49.3693 518.696 49.3693C518.133 49.366 517.57 49.4129 517.016 49.5093",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M525.998 60.3476V60.1656C525.998 58.2346 525.23 56.3827 523.865 55.0173C522.5 53.6519 520.648 52.8848 518.717 52.8848C517.126 52.8835 515.579 53.4104 514.32 54.3829",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M517.184 56.4551C516.719 56.6486 516.296 56.929 515.938 57.2812",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M522.729 60.2629V60.1649C522.729 59.0992 522.306 58.0771 521.552 57.3235C520.799 56.5699 519.777 56.1465 518.711 56.1465",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M428.263 58.1074C428.163 58.7983 428.111 59.4955 428.109 60.1936C428.109 60.3197 428.109 60.4317 428.109 60.5577",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M445.571 45.8976C444.618 45.7 443.646 45.6014 442.673 45.6035C439.623 45.6023 436.651 46.5584 434.174 48.337C431.697 50.1156 429.841 52.6268 428.867 55.5166",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M450.638 47.9982C449.713 47.3887 448.722 46.8861 447.684 46.5",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M441.805 49.4121C442.085 49.4121 442.379 49.4121 442.673 49.4121C444.864 49.4142 447.003 50.0832 448.805 51.3303",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M431.895 60.4317C431.895 60.3477 431.895 60.2637 431.895 60.1657C431.895 58.044 432.521 55.9695 433.694 54.2014C434.867 52.4334 436.535 51.0502 438.489 50.2246",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M435.375 60.3476V60.1656C435.375 58.2346 436.142 56.3827 437.507 55.0173C438.873 53.6519 440.725 52.8848 442.656 52.8848C444.247 52.8835 445.793 53.4104 447.052 54.3829",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M438.666 60.263C438.658 60.2308 438.658 60.1972 438.666 60.165C438.662 59.3749 438.891 58.6011 439.326 57.9412C439.76 57.2812 440.38 56.7646 441.108 56.4562C441.835 56.1478 442.637 56.0616 443.414 56.2083C444.19 56.355 444.906 56.7281 445.471 57.2807",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M259.837 316.324L250.036 296.931C249.915 296.681 249.699 296.489 249.437 296.397C249.174 296.305 248.886 296.321 248.635 296.441C248.39 296.568 248.202 296.783 248.111 297.044C248.02 297.304 248.032 297.59 248.145 297.841L257.526 317.444C257.333 317.638 257.2 317.885 257.145 318.153C257.09 318.422 257.116 318.701 257.218 318.956L267.131 337.55C267.397 338.068 268.252 338.18 269.036 337.802C269.82 337.424 270.254 336.668 270.002 336.136L261.307 316.94C261.146 316.708 260.922 316.527 260.661 316.417C260.401 316.308 260.115 316.276 259.837 316.324Z",
    fill: "#2E353A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M314.126 316.323L323.927 296.931C323.982 296.796 324.065 296.673 324.169 296.571C324.274 296.469 324.398 296.389 324.535 296.337C324.672 296.285 324.817 296.262 324.963 296.269C325.109 296.276 325.252 296.313 325.384 296.377C325.515 296.442 325.631 296.533 325.726 296.644C325.82 296.756 325.89 296.886 325.932 297.026C325.975 297.166 325.987 297.313 325.97 297.458C325.953 297.603 325.906 297.743 325.832 297.869L316.465 317.471C316.656 317.667 316.786 317.915 316.838 318.183C316.891 318.452 316.863 318.73 316.759 318.984L306.846 337.578C306.58 338.096 305.739 338.208 304.941 337.83C304.143 337.452 303.723 336.695 303.975 336.163L312.67 316.967C312.827 316.733 313.047 316.548 313.305 316.433C313.563 316.319 313.848 316.281 314.126 316.323Z",
    fill: "#2E353A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M317.859 338.417H256.309L260.915 330.59H313.239L317.859 338.417Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M317.859 338.418H256.309V346.259H317.859V338.418Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M286.024 340.615H262.347C261.396 340.615 260.625 341.386 260.625 342.337V342.351C260.625 343.303 261.396 344.074 262.347 344.074H286.024C286.975 344.074 287.746 343.303 287.746 342.351V342.337C287.746 341.386 286.975 340.615 286.024 340.615Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M300.336 343.653C301.172 343.653 301.849 342.976 301.849 342.141C301.849 341.306 301.172 340.629 300.336 340.629C299.501 340.629 298.824 341.306 298.824 342.141C298.824 342.976 299.501 343.653 300.336 343.653Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M308.115 342.142C308.118 341.839 308.03 341.542 307.863 341.289C307.697 341.035 307.459 340.838 307.179 340.72C306.9 340.603 306.592 340.572 306.294 340.63C305.997 340.689 305.724 340.834 305.51 341.049C305.295 341.263 305.15 341.536 305.091 341.833C305.033 342.131 305.064 342.439 305.181 342.718C305.299 342.998 305.496 343.236 305.749 343.402C306.003 343.569 306.3 343.657 306.603 343.654C307.004 343.654 307.388 343.495 307.672 343.211C307.955 342.927 308.115 342.543 308.115 342.142Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M312.86 343.653C313.695 343.653 314.372 342.976 314.372 342.141C314.372 341.306 313.695 340.629 312.86 340.629C312.025 340.629 311.348 341.306 311.348 342.141C311.348 342.976 312.025 343.653 312.86 343.653Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M332.383 284.637C334.597 285.913 336.436 287.75 337.716 289.961C338.997 292.173 339.673 294.682 339.678 297.238C339.678 297.364 339.678 297.476 339.678 297.602",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M317.133 285.085C319.504 283.53 322.278 282.703 325.114 282.705C326.719 282.699 328.315 282.964 329.832 283.489",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M323.224 286.625C321.717 286.908 320.286 287.504 319.023 288.375",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M335.965 297.533C335.965 297.449 335.965 297.364 335.965 297.266C335.961 294.589 334.964 292.009 333.166 290.025C331.368 288.041 328.898 286.794 326.234 286.527",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M330.367 292.199C329.692 291.496 328.88 290.938 327.983 290.557C327.085 290.177 326.12 289.983 325.145 289.986C323.552 289.987 322.004 290.509 320.734 291.471",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M332.383 297.435C332.383 297.435 332.383 297.323 332.383 297.253C332.377 296.291 332.182 295.34 331.809 294.453",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M324.138 293.332C323.459 293.505 322.836 293.853 322.332 294.34",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M329.118 297.35C329.118 297.35 329.118 297.35 329.118 297.252C329.131 296.364 328.847 295.496 328.312 294.786C327.778 294.077 327.022 293.565 326.164 293.332",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M234.706 294.816C234.565 295.621 234.495 296.436 234.496 297.253C234.496 297.379 234.496 297.491 234.496 297.617",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M243.318 283.867C241.527 284.644 239.909 285.77 238.558 287.178C237.207 288.587 236.151 290.251 235.449 292.072",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M257.026 285.085C254.66 283.531 251.89 282.703 249.059 282.705C248.076 282.702 247.096 282.801 246.133 282.999",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M240.906 290.182C242.649 288.18 245.069 286.889 247.703 286.556C250.337 286.223 253.001 286.871 255.188 288.376",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M238.281 297.533C238.281 297.449 238.281 297.365 238.281 297.267C238.282 295.669 238.636 294.092 239.317 292.646",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M243.848 292.171C245.089 290.904 246.749 290.134 248.518 290.006C250.286 289.877 252.041 290.398 253.453 291.47",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M241.789 297.436C241.789 297.436 241.789 297.324 241.789 297.254C241.786 296.167 242.03 295.095 242.503 294.117",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M246.426 294.214C247.188 293.565 248.164 293.221 249.165 293.25C250.166 293.278 251.12 293.677 251.844 294.368",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M245.055 297.351C245.055 297.351 245.055 297.351 245.055 297.253C245.055 296.594 245.218 295.944 245.531 295.363",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5815 198.249L22.7804 178.857C22.7254 178.722 22.6431 178.599 22.5386 178.497C22.4341 178.394 22.3096 178.315 22.173 178.263C22.0364 178.211 21.8905 178.188 21.7445 178.195C21.5985 178.201 21.4554 178.238 21.3243 178.303C21.1932 178.368 21.0768 178.458 20.9823 178.57C20.8879 178.682 20.8175 178.811 20.7754 178.951C20.7334 179.091 20.7206 179.239 20.738 179.384C20.7553 179.529 20.8024 179.669 20.8762 179.795L30.2432 199.397C30.0484 199.594 29.9124 199.841 29.8506 200.11C29.7887 200.38 29.8035 200.662 29.8932 200.923L39.8063 219.517C40.0723 220.035 40.9124 220.147 41.7105 219.755C42.5086 219.363 42.9286 218.635 42.6626 218.103L33.9817 198.907C33.8313 198.679 33.6211 198.497 33.3741 198.381C33.1271 198.265 32.8528 198.219 32.5815 198.249Z",
    fill: "#2E353A"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8504 198.247L96.6514 178.855C96.7723 178.605 96.9877 178.413 97.2502 178.321C97.5127 178.229 97.8009 178.245 98.0516 178.365C98.2969 178.491 98.4845 178.707 98.5757 178.968C98.6669 179.228 98.6547 179.514 98.5416 179.765L89.1606 199.367C89.3748 199.557 89.5258 199.807 89.5934 200.085C89.661 200.363 89.6419 200.655 89.5386 200.922L79.6256 219.516C79.3595 220.034 78.5054 220.146 77.7214 219.754C76.9373 219.362 76.5032 218.634 76.7553 218.101L85.4502 198.905C85.5994 198.676 85.8094 198.494 86.0567 198.377C86.304 198.261 86.5789 198.216 86.8504 198.247Z",
    fill: "#2E353A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6015 220.343H29.0508L33.6573 212.502H85.9809L90.6015 220.343Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5897 220.342H29.0391V228.183H90.5897V220.342Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7379 225.999H35.0894C34.6313 225.996 34.1933 225.811 33.8708 225.486C33.5482 225.161 33.3672 224.721 33.3672 224.263C33.3672 223.806 33.5486 223.368 33.8716 223.045C34.1946 222.722 34.6326 222.541 35.0894 222.541H58.7379C59.1947 222.541 59.6327 222.722 59.9557 223.045C60.2787 223.368 60.4601 223.806 60.4601 224.263C60.4601 224.721 60.2791 225.161 59.9566 225.486C59.634 225.811 59.196 225.996 58.7379 225.999Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0707 225.565C73.9059 225.565 74.5829 224.888 74.5829 224.053C74.5829 223.218 73.9059 222.541 73.0707 222.541C72.2356 222.541 71.5586 223.218 71.5586 224.053C71.5586 224.888 72.2356 225.565 73.0707 225.565Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3325 225.565C80.1676 225.565 80.8446 224.888 80.8446 224.053C80.8446 223.218 80.1676 222.541 79.3325 222.541C78.4973 222.541 77.8203 223.218 77.8203 224.053C77.8203 224.888 78.4973 225.565 79.3325 225.565Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1187 224.053C87.1187 223.751 87.0289 223.455 86.8605 223.204C86.6922 222.953 86.453 222.757 86.1733 222.642C85.8936 222.527 85.5861 222.498 85.2896 222.558C84.9932 222.618 84.7213 222.764 84.5084 222.979C84.2956 223.194 84.1513 223.467 84.094 223.764C84.0367 224.061 84.069 224.369 84.1866 224.647C84.3043 224.926 84.5021 225.163 84.7549 225.329C85.0077 225.495 85.3041 225.582 85.6066 225.58C85.8063 225.58 86.0041 225.54 86.1885 225.463C86.3729 225.386 86.5402 225.274 86.6808 225.132C86.8214 224.99 86.9325 224.822 87.0077 224.636C87.0828 224.451 87.1206 224.253 87.1187 224.053Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M111.605 174.404C112.135 175.94 112.405 177.554 112.404 179.179C112.404 179.305 112.404 179.417 112.404 179.543",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M100.738 164.896C102.967 165.347 105.059 166.31 106.851 167.71C108.642 169.11 110.082 170.908 111.057 172.961",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M89.875 167.011C91.818 165.73 94.0422 164.937 96.3577 164.701",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M105.962 172.066C104.22 170.073 101.806 168.792 99.1791 168.466C96.5525 168.141 93.8981 168.794 91.7227 170.302",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M108.626 179.444C108.633 179.355 108.633 179.266 108.626 179.178C108.628 177.448 108.215 175.744 107.422 174.207",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3436 172.064C95.2845 172.307 94.2938 172.786 93.4453 173.465",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M105.12 179.361V179.179C105.121 177.523 104.557 175.917 103.52 174.627C102.484 173.336 101.038 172.437 99.4219 172.08",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M101.007 176.701C100.662 176.257 100.228 175.892 99.7317 175.628C99.2358 175.364 98.6899 175.208 98.1295 175.169C97.5691 175.131 97.0069 175.212 96.4798 175.405C95.9526 175.599 95.4723 175.902 95.0703 176.295",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M101.859 179.276V179.178C101.862 178.784 101.805 178.392 101.691 178.016",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2516 164.84C15.8842 165.438 12.835 167.203 10.6384 169.825C8.44183 172.446 7.23812 175.757 7.23828 179.177C7.23828 179.303 7.23828 179.415 7.23828 179.541",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7703 167.01C27.6773 165.638 25.2664 164.828 22.7695 164.658",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1836 168.719C25.5216 169.009 26.7941 169.546 27.936 170.301",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 179.444C11.0195 179.36 11.0195 179.276 11.0195 179.178C11.0195 176.315 12.1569 173.569 14.1814 171.545C16.2059 169.52 18.9516 168.383 21.8147 168.383",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1836 174.558C17.3741 173.102 19.085 172.166 20.9537 171.949C22.8224 171.732 24.7021 172.251 26.1947 173.396",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5156 179.359V179.177C14.5151 178.215 14.7104 177.262 15.0897 176.377",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5156 175.23C23.296 175.374 24.0168 175.744 24.5878 176.295",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M17.793 179.275C17.793 179.275 17.793 179.275 17.793 179.177C17.7962 178.227 18.1351 177.308 18.75 176.583C19.3648 175.858 20.216 175.373 21.1533 175.215",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M352.846 354.434H228.078V439.913H352.846V354.434Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M371.569 477.702H209.375L228.081 439.912H352.849L371.569 477.702Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M345.287 361.197H235.641V433.151H345.287V361.197Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M306.889 390.263L290.493 370.871L274.098 390.263H280.958V420.632H300.028V390.263H306.889Z",
    fill: "#FFA42A"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M285.26 451.884L285.47 447.277H278.889L278.441 451.884H285.26Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M298.885 451.884L298.661 447.277H292.066L292.08 451.884H298.885Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M334.359 456.799H341.416L339.75 451.885H332.945L334.359 456.799Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M278.445 451.884L278.893 447.277H272.299L271.641 451.884H278.445Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M264.82 451.884L265.702 447.277H259.108L258.016 451.884H264.82Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M326.134 451.884L325.028 447.277H318.434L319.33 451.884H326.134Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M332.948 451.884L331.618 447.277H325.023L326.13 451.884H332.948Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M258.01 451.884L259.102 447.277H252.508L251.191 451.884H258.01Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M305.699 451.884L305.251 447.277H298.656L298.88 451.884H305.699Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M339.752 451.884L338.212 447.277H331.617L332.947 451.884H339.752Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M319.324 451.884L318.428 447.277H311.848L312.506 451.884H319.324Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M312.511 451.884L311.853 447.277H305.258L305.706 451.884H312.511Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M292.084 451.884L292.07 447.277H285.476L285.266 451.884H292.084Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M244.386 451.885H237.568L235.691 456.799H242.734L244.386 451.885Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M245.915 447.277H239.335L237.57 451.884H244.389L245.915 447.277Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M251.195 451.884L252.511 447.277H245.917L244.391 451.884H251.195Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M233.678 462.078L231.508 467.749H239.083L240.973 462.078H233.678Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M242.739 456.799H235.696L233.68 462.077H240.974L242.739 456.799Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M240.972 462.078L239.082 467.749H246.657L248.281 462.078H240.972Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M271.635 451.884L272.293 447.277H265.699L264.816 451.884H271.635Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M270.936 456.799L271.636 451.885H264.817L263.879 456.799H270.936Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M263.883 456.799L264.821 451.885H258.016L256.84 456.799H263.883Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M277.984 456.799L278.446 451.885H271.641L270.941 456.799H277.984Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M251.195 451.885H244.39L242.738 456.799H249.795L251.195 451.885Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M335.889 462.077H343.184L341.42 456.799H334.363L335.889 462.077Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M256.836 456.799L258.012 451.885H251.193L249.793 456.799H256.836Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M242.737 456.799L240.973 462.077H248.281L249.794 456.799H242.737Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M320.265 456.799L319.327 451.885H312.508L313.222 456.799H320.265Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M313.222 456.799L312.508 451.885H305.703L306.179 456.799H313.222Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M334.366 456.799L332.952 451.885H326.133L327.323 456.799H334.366Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M292.076 456.799V451.885H285.258L285.02 456.799H292.076Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M306.178 456.799L305.702 451.885H298.883L299.121 456.799H306.178Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M299.125 456.799L298.887 451.885H292.082V456.799H299.125Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M285.023 456.799L285.261 451.885H278.443L277.98 456.799H285.023Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M306.18 456.799L306.684 462.077H313.993L313.222 456.799H306.18Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M313.223 456.799L313.993 462.077H321.288L320.265 456.799H313.223Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M249.797 456.799L248.285 462.077H255.58L256.84 456.799H249.797Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M320.27 456.799L321.292 462.077H328.586L327.326 456.799H320.27Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M292.082 456.799V462.077H299.391L299.125 456.799H292.082Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M327.32 456.799L328.58 462.077H335.889L334.363 456.799H327.32Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M299.121 456.799L299.387 462.077H306.682L306.178 456.799H299.121Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M263.879 456.799L262.871 462.077H270.18L270.936 456.799H263.879Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M256.838 456.799L255.578 462.077H262.873L263.881 456.799H256.838Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M285.027 456.799L284.789 462.077H292.084V456.799H285.027Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M277.981 456.799L277.477 462.077H284.785L285.023 456.799H277.981Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M270.94 456.799L270.184 462.077H277.478L277.982 456.799H270.94Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M327.323 456.799L326.133 451.885H319.328L320.266 456.799H327.323Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M245.913 447.277L247.495 442.559H241.124L239.332 447.277H245.913Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M239.336 447.277H233.245L231.285 451.884H237.572L239.336 447.277Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M241.129 442.559H235.262L233.246 447.277H239.337L241.129 442.559Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M237.57 451.885H231.284L229.184 456.799H235.694L237.57 451.885Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M235.695 456.799H229.184L226.93 462.077H233.678L235.695 456.799Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M233.684 462.078H226.936L224.527 467.749H231.514L233.684 462.078Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M346.57 451.885L348.461 456.799H354.691L352.591 451.885H346.57Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M350.491 462.077H356.946L354.692 456.799H348.461L350.491 462.077Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M352.662 467.749H359.355L356.947 462.078H350.492L352.662 467.749Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M298.661 447.277L298.437 442.559H292.066V447.277H298.661Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M346.569 451.884H352.59L350.629 447.277H344.805L346.569 451.884Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M343.186 462.077H350.495L348.465 456.799H341.422L343.186 462.077Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M252.513 447.277L253.871 442.559H247.5L245.918 447.277H252.513Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M338.215 447.277L339.755 451.884H346.574L344.81 447.277H338.215Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M350.637 447.277L348.635 442.559H342.992L344.812 447.277H350.637Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M344.81 447.277L342.989 442.559H336.633L338.215 447.277H344.81Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M321.285 462.078L322.377 467.749H329.952L328.58 462.078H321.285Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M345.092 467.749H352.667L350.496 462.078H343.188L345.092 467.749Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M338.218 447.277L336.636 442.559H330.266L331.624 447.277H338.218Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M335.891 462.078L337.515 467.749H345.09L343.185 462.078H335.891Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M328.582 462.078L329.954 467.749H337.515L335.891 462.078H328.582Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M341.42 456.799H348.463L346.573 451.885H339.754L341.42 456.799Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M278.888 447.277L279.336 442.559H272.965L272.293 447.277H278.888Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M331.619 447.277L330.261 442.559H323.891L325.025 447.277H331.619Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M272.294 447.277L272.966 442.559H266.595L265.699 447.277H272.294Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M292.063 447.277V442.559H285.693L285.469 447.277H292.063Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M265.704 447.277L266.6 442.559H260.23L259.109 447.277H265.704Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M259.106 447.277L260.227 442.559H253.87L252.512 447.277H259.106Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M285.471 447.277L285.695 442.559H279.339L278.891 447.277H285.471Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M325.026 447.277L323.892 442.559H317.535L318.431 447.277H325.026Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M318.427 447.277L317.531 442.559H311.16L311.846 447.277H318.427Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M305.252 447.277L304.79 442.559H298.434L298.658 447.277H305.252Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M321.288 462.078H313.993H306.685H299.39H292.081H284.786H277.477H270.183H262.874H255.579H248.284L246.66 467.749H254.235H261.796H269.371H276.945H284.52H292.081H299.656H307.231H314.806H322.38L321.288 462.078Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M311.85 447.277L311.164 442.559H304.793L305.255 447.277H311.85Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M371.639 477.703H209.375V479.999H371.639V477.703Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M398.757 354.434H493.967V439.913H398.757C398.155 439.913 397.578 439.674 397.153 439.248C396.727 438.823 396.488 438.246 396.488 437.645V356.716C396.486 356.417 396.544 356.12 396.657 355.843C396.77 355.567 396.937 355.315 397.148 355.103C397.358 354.891 397.609 354.722 397.885 354.608C398.161 354.493 398.458 354.434 398.757 354.434Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M497.243 354.434H399.051V439.913H497.243V354.434Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M491.879 361.197H406.609V433.151H491.879V361.197Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M435.734 390.263L448.448 370.871L461.161 390.263H455.841V420.632H441.055V390.263H435.734Z",
    fill: "#FFA42A"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M399.051 439.912L473.483 461.432H573.832L497.243 439.912H399.051Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M478.534 448.427L469.223 445.78L465.148 445.738L474.431 448.399L478.534 448.427Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M486.647 448.497L477.308 445.864L473.289 445.822L482.6 448.469L486.647 448.497Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M516.075 451.283L519.968 451.311L510.293 448.665L506.414 448.637L516.075 451.283Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M474.436 448.398L465.153 445.737L461.051 445.695L470.306 448.37L474.436 448.398Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M466.163 448.341L456.908 445.667L452.75 445.625L461.977 448.313L466.163 448.341Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M502.519 448.607L493.11 446.003L489.203 445.975L498.584 448.579L502.519 448.607Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M506.415 448.636L496.992 446.046L493.113 446.004L502.522 448.608L506.415 448.636Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M461.974 448.314L452.747 445.626L448.547 445.584L457.746 448.286L461.974 448.314Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M490.648 448.524L481.295 445.891L477.305 445.863L486.644 448.496L490.648 448.524Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M510.294 448.663L500.857 446.087L496.992 446.045L506.415 448.635L510.294 448.663Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M498.591 448.58L489.21 445.976L485.262 445.934L494.643 448.552L498.591 448.58Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M494.64 448.551L485.259 445.933L481.297 445.891L490.65 448.523L494.64 448.551Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M482.598 448.468L473.287 445.821L469.227 445.779L478.538 448.426L482.598 448.468Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M453.503 448.243L449.219 448.215L458.628 451.001L462.926 451.029L453.503 448.243Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M444.315 445.542L440.059 445.5L449.216 448.216L453.5 448.244L444.315 445.542Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M457.744 448.285L448.545 445.583L444.316 445.541L453.501 448.243L457.744 448.285Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M468.273 453.857L478.201 456.798H482.541L472.6 453.871L468.273 453.857Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M462.927 451.03L458.629 451.002L468.276 453.858L472.602 453.872L462.927 451.03Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M472.602 453.873L482.543 456.799H486.855L476.886 453.887L472.602 453.873Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M470.306 448.37L461.051 445.696L456.906 445.668L466.161 448.342L470.306 448.37Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M479.812 451.114L470.305 448.37L466.16 448.342L475.639 451.086L479.812 451.114Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M475.642 451.087L466.163 448.342L461.977 448.314L471.442 451.073L475.642 451.087Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M483.956 451.127L474.435 448.397L470.305 448.369L479.812 451.113L483.956 451.127Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M457.742 448.286L453.5 448.244L462.923 451.03L467.193 451.044L457.742 448.286Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M525.987 454.012L529.88 454.026L519.967 451.309L516.074 451.281L525.987 454.012Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M471.44 451.071L461.975 448.313L457.746 448.285L467.197 451.043L471.44 451.071Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M462.93 451.029L472.605 453.872L476.889 453.886L467.2 451.043L462.93 451.029Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M508.222 451.255L498.589 448.581L494.641 448.553L504.246 451.227L508.222 451.255Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M504.244 451.226L494.639 448.551L490.648 448.523L500.253 451.212L504.244 451.226Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M516.073 451.282L506.412 448.635L502.52 448.607L512.167 451.268L516.073 451.282Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M492.159 451.17L482.596 448.468L478.535 448.426L488.07 451.142L492.159 451.17Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M500.258 451.212L490.653 448.524L486.648 448.496L496.225 451.184L500.258 451.212Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M496.221 451.183L486.644 448.495L482.598 448.467L492.161 451.169L496.221 451.183Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M488.067 451.143L478.532 448.426L474.43 448.398L483.951 451.129L488.067 451.143Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M500.25 451.213L510.093 453.971L514.111 453.985L504.24 451.227L500.25 451.213Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M504.242 451.227L514.113 453.985L518.09 453.999L508.219 451.255L504.242 451.227Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M467.195 451.045L476.884 453.887L481.155 453.901L471.438 451.073L467.195 451.045Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M508.223 451.254L518.094 453.998H522.056L512.171 451.268L508.223 451.254Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M492.16 451.17L501.975 453.942L506.05 453.956L496.221 451.184L492.16 451.17Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M512.172 451.268L522.057 453.998L525.991 454.012L516.078 451.282L512.172 451.268Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M496.223 451.184L506.052 453.956L510.098 453.97L500.255 451.212L496.223 451.184Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M475.645 451.086L485.376 453.914H489.576L479.817 451.114L475.645 451.086Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M471.441 451.072L481.158 453.901L485.373 453.915L475.642 451.086L471.441 451.072Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M488.07 451.143L497.871 453.943H501.974L492.159 451.171L488.07 451.143Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M483.957 451.129L493.744 453.929L497.875 453.943L488.073 451.143L483.957 451.129Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M479.812 451.113L489.572 453.914L493.744 453.928L483.957 451.127L479.812 451.113Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M512.171 451.268L502.524 448.608L498.59 448.58L508.223 451.254L512.171 451.268Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M444.316 445.542L434.529 442.657L430.301 442.615L440.06 445.5L444.316 445.542Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M440.064 445.499L436.102 445.457L445.245 448.187L449.221 448.215L440.064 445.499Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M430.306 442.615L426.371 442.559L436.102 445.457L440.065 445.499L430.306 442.615Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M449.219 448.215L445.242 448.188L454.623 450.988L458.628 451.002L449.219 448.215Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M458.626 451.002L454.621 450.988L464.254 453.859H468.273L458.626 451.002Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M468.272 453.857H464.254L474.153 456.798H478.199L468.272 453.857Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M514.141 448.691L523.83 451.324L527.218 451.352L517.515 448.719L514.141 448.691Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M533.763 454.027L537.165 454.041L527.224 451.352L523.836 451.324L533.763 454.027Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M543.947 456.798H547.349L537.156 454.039L533.754 454.025L543.947 456.798Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M477.302 445.864L467.333 443.05L463.328 443.008L473.283 445.822L477.302 445.864Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M514.145 448.692L517.519 448.72L508.054 446.157L504.68 446.115L514.145 448.692Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M529.882 454.027H533.76L523.833 451.325L519.969 451.311L529.882 454.027Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M448.547 445.583L438.732 442.712L434.531 442.656L444.318 445.541L448.547 445.583Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M500.859 446.088L510.296 448.664L514.147 448.692L504.682 446.116L500.859 446.088Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M508.053 446.157L497.944 443.413L494.598 443.371L504.679 446.115L508.053 446.157Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M504.677 446.116L494.596 443.372L490.773 443.33L500.855 446.088L504.677 446.116Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M518.094 453.998L528.231 456.798H532.207L522.056 453.998H518.094Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M540.062 456.798H543.954L533.761 454.025H529.883L540.062 456.798Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M500.859 446.087L490.778 443.329L486.941 443.287L496.995 446.045L500.859 446.087Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M525.988 454.012L536.139 456.798H540.06L529.881 454.026L525.988 454.012Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M522.059 453.998L532.21 456.798H536.144L525.993 454.012L522.059 453.998Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M519.972 451.31L523.836 451.324L514.147 448.692L510.297 448.664L519.972 451.31Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M465.155 445.738L455.256 442.909L451.168 442.854L461.053 445.696L465.155 445.738Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M496.992 446.045L486.939 443.286L483.074 443.23L493.113 446.003L496.992 446.045Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M461.052 445.695L451.167 442.853L447.051 442.811L456.908 445.667L461.052 445.695Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M473.29 445.822L463.335 443.007L459.316 442.951L469.229 445.78L473.29 445.822Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M456.904 445.668L447.047 442.812L442.902 442.756L452.745 445.626L456.904 445.668Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M452.75 445.625L442.907 442.755L438.734 442.713L448.549 445.583L452.75 445.625Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M469.223 445.779L459.31 442.95L455.25 442.908L465.149 445.737L469.223 445.779Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M493.111 446.004L483.072 443.231L479.18 443.189L489.205 445.976L493.111 446.004Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M489.211 445.975L479.186 443.188L475.266 443.146L485.263 445.933L489.211 445.975Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M481.295 445.891L471.312 443.091L467.336 443.049L477.305 445.863L481.295 445.891Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M518.089 453.999L514.113 453.985L510.094 453.971L506.048 453.957L501.974 453.943H497.871L493.741 453.929L489.568 453.915H485.368L481.153 453.901L476.883 453.887L486.852 456.799H491.122H495.379H499.593H503.766H507.924H512.041H516.129H520.189H524.222H528.226L518.089 453.999Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M485.258 445.934L475.261 443.148L471.312 443.092L481.296 445.892L485.258 445.934Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M399.051 439.912V442.768L473.455 465.101L473.483 461.432L399.051 439.912Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M573.833 461.434H473.484V465.088H573.833V461.434Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M178.486 439.912H83.2753L83.2753 354.433H178.486C179.087 354.433 179.664 354.672 180.09 355.097C180.515 355.523 180.754 356.1 180.754 356.701V437.63C180.756 437.929 180.698 438.225 180.585 438.502C180.472 438.779 180.305 439.031 180.094 439.243C179.884 439.455 179.633 439.623 179.357 439.738C179.081 439.853 178.785 439.912 178.486 439.912Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9949 439.912H178.188V354.433H79.9949L79.9949 439.912Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3597 433.15H170.629V361.197H85.3597L85.3597 433.15Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M136.173 390.263L123.459 370.871L110.746 390.263H116.067V420.632H130.852V390.263H136.173Z",
    fill: "#FFA42A"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M178.191 439.912L103.759 461.432H3.41016L79.9985 439.912H178.191Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7031 448.427L108.014 445.78L112.089 445.738L102.806 448.399L98.7031 448.427Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6016 448.497L99.9406 445.864L103.959 445.822L94.648 448.469L90.6016 448.497Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M61.162 451.283L57.2695 451.311L66.9446 448.665L70.823 448.637L61.162 451.283Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M102.809 448.398L112.092 445.737L116.194 445.695L106.939 448.37L102.809 448.398Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M111.082 448.341L120.337 445.667L124.495 445.625L115.268 448.313L111.082 448.341Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7188 448.607L84.1278 446.003L88.0342 445.975L78.6532 448.579L74.7188 448.607Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8242 448.636L80.2472 446.046L84.1257 446.004L74.7166 448.608L70.8242 448.636Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M115.27 448.314L124.497 445.626L128.697 445.584L119.498 448.286L115.27 448.314Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5938 448.524L95.9468 445.891L99.9372 445.863L90.5982 448.496L86.5938 448.524Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9531 448.663L76.3901 446.087L80.2546 446.045L70.8315 448.635L66.9531 448.663Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6562 448.58L88.0373 445.976L91.9857 445.934L82.6047 448.552L78.6562 448.58Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6016 448.551L91.9826 445.933L95.945 445.891L86.592 448.523L82.6016 448.551Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6406 448.468L103.952 445.821L108.012 445.779L98.7011 448.426L94.6406 448.468Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M123.739 448.243L128.024 448.215L118.615 451.001L114.316 451.029L123.739 448.243Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M132.923 445.542L137.18 445.5L128.023 448.216L123.738 448.244L132.923 445.542Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M119.496 448.285L128.695 445.583L132.924 445.541L123.739 448.243L119.496 448.285Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M108.967 453.857L99.0397 456.798H94.6992L104.64 453.871L108.967 453.857Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M114.312 451.03L118.61 451.002L108.963 453.858L104.637 453.872L114.312 451.03Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M104.644 453.873L94.7031 456.799H90.3906L100.346 453.887L104.644 453.873Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M106.934 448.37L116.189 445.696L120.333 445.668L111.078 448.342L106.934 448.37Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4297 451.114L106.937 448.37L111.081 448.342L101.602 451.086L97.4297 451.114Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M101.605 451.087L111.084 448.342L115.271 448.314L105.806 451.073L101.605 451.087Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2891 451.127L102.81 448.397L106.941 448.369L97.4335 451.113L93.2891 451.127Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M119.498 448.286L123.74 448.244L114.317 451.03L110.047 451.044L119.498 448.286Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2518 454.012L47.3594 454.026L57.2725 451.309L61.1649 451.281L51.2518 454.012Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M105.801 451.071L115.266 448.313L119.494 448.285L110.043 451.043L105.801 451.071Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M114.317 451.029L104.642 453.872L100.344 453.886L110.047 451.043L114.317 451.029Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0234 451.255L78.6565 448.581L82.6049 448.553L72.9999 451.227L69.0234 451.255Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9961 451.226L82.6011 448.551L86.5916 448.523L76.9865 451.212L72.9961 451.226Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1641 451.282L70.8251 448.635L74.7175 448.607L65.0705 451.268L61.1641 451.282Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0781 451.17L94.6412 448.468L98.7016 448.426L89.1666 451.142L85.0781 451.17Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9883 451.212L86.5933 448.524L90.5978 448.496L81.0207 451.184L76.9883 451.212Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0156 451.183L90.5927 448.495L94.6391 448.467L85.0761 451.169L81.0156 451.183Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1719 451.143L98.7069 448.426L102.809 448.398L93.2883 451.129L89.1719 451.143Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9865 451.213L67.1434 453.971L63.125 453.985L72.9961 451.227L76.9865 451.213Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9959 451.227L63.1249 453.985L59.1484 453.999L69.0195 451.255L72.9959 451.227Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M110.045 451.045L100.342 453.887L96.0859 453.901L105.803 451.073L110.045 451.045Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0249 451.254L59.1538 453.998H55.1914L65.0765 451.268L69.0249 451.254Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M85.077 451.17L75.2619 453.942L71.1875 453.956L81.0166 451.184L85.077 451.17Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0734 451.268L55.1883 453.998L51.2539 454.012L61.167 451.282L65.0734 451.268Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0239 451.184L71.1949 453.956L67.1484 453.97L76.9915 451.212L81.0239 451.184Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M101.603 451.086L91.8723 453.914H87.6719L97.4309 451.114L101.603 451.086Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M105.807 451.072L96.0895 453.901L91.875 453.915L101.606 451.086L105.807 451.072Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1691 451.143L79.3681 453.943H75.2656L85.0807 451.171L89.1691 451.143Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2886 451.129L83.5015 453.929L79.3711 453.943L89.1722 451.143L93.2886 451.129Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4276 451.113L87.6685 453.914L83.4961 453.928L93.2832 451.127L97.4276 451.113Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0742 451.268L74.7213 448.608L78.6557 448.58L69.0226 451.254L65.0742 451.268Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M132.922 445.542L142.709 442.657L146.937 442.615L137.178 445.5L132.922 445.542Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M137.184 445.499L141.147 445.457L132.004 448.187L128.027 448.215L137.184 445.499Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M146.943 442.615L150.877 442.559L141.146 445.457L137.184 445.499L146.943 442.615Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M128.022 448.215L131.999 448.188L122.618 450.988L118.613 451.002L128.022 448.215Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M118.612 451.002L122.616 450.988L112.983 453.859H108.965L118.612 451.002Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M108.966 453.857H112.985L103.085 456.798H99.0391L108.966 453.857Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M63.097 448.691L53.4079 451.324L50.0195 451.352L59.7226 448.719L63.097 448.691Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4844 454.027L40.082 454.041L50.0231 451.352L53.4115 451.324L43.4844 454.027Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2891 456.798H29.8867L40.0798 454.039L43.4822 454.025L33.2891 456.798Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9375 445.864L109.907 443.05L113.911 443.008L103.956 445.822L99.9375 445.864Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M63.097 448.692L59.7227 448.72L69.1877 446.157L72.5481 446.115L63.097 448.692Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3628 454.027H43.4844L53.4114 451.325L57.2759 451.311L47.3628 454.027Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M128.699 445.583L138.514 442.712L142.715 442.656L132.928 445.541L128.699 445.583Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3851 446.088L66.9481 448.664L63.0977 448.692L72.5487 446.116L76.3851 446.088Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1914 446.157L79.3005 443.413L82.6469 443.371L72.5518 446.115L69.1914 446.157Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5469 446.116L82.642 443.372L86.4644 443.33L76.3833 446.088L72.5469 446.116Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1448 453.998L49.0077 456.798H45.0312L55.1824 453.998H59.1448Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1776 456.798H33.2852L43.4783 454.025H47.3567L37.1776 456.798Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3867 446.087L86.4678 443.329L90.3042 443.287L80.2511 446.045L76.3867 446.087Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2512 454.012L41.1001 456.798H37.1797L47.3588 454.026L51.2512 454.012Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1871 453.998L45.036 456.798H41.1016L51.2527 454.012L55.1871 453.998Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2746 451.31L53.4102 451.324L63.0992 448.692L66.9496 448.664L57.2746 451.31Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M112.09 445.738L121.989 442.909L126.077 442.854L116.192 445.696L112.09 445.738Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2461 446.045L90.2992 443.286L94.1636 443.23L84.1245 446.003L80.2461 446.045Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M116.195 445.695L126.08 442.853L130.197 442.811L120.34 445.667L116.195 445.695Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M103.957 445.822L113.912 443.007L117.931 442.951L108.017 445.78L103.957 445.822Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M120.336 445.668L130.193 442.812L134.337 442.756L124.494 445.626L120.336 445.668Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M124.496 445.625L134.339 442.755L138.512 442.713L128.697 445.583L124.496 445.625Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M108.016 445.779L117.929 442.95L121.989 442.908L112.09 445.737L108.016 445.779Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1289 446.004L94.168 443.231L98.0604 443.189L88.0353 445.976L84.1289 446.004Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0352 445.975L98.0602 443.188L101.981 443.146L91.9836 445.933L88.0352 445.975Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9453 445.891L105.928 443.091L109.905 443.049L99.9357 445.863L95.9453 445.891Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1488 453.999L63.1253 453.985L67.1437 453.971L71.1901 453.957L75.2646 453.943H79.367L83.4975 453.929L87.6699 453.915H91.8704L96.0848 453.901L100.341 453.887L90.3862 456.799H86.1157H81.8593H77.6588H73.4724H69.3139H65.1975H61.109H57.0486H53.0162H49.0117L59.1488 453.999Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9883 445.934L101.985 443.148L105.934 443.092L95.9507 445.892L91.9883 445.934Z",
    fill: "white",
    stroke: "#2E353A",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M178.194 439.912V442.768L103.776 465.101L103.762 461.432L178.194 439.912Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41285 465.102H103.762V461.447H3.41285V465.102Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.85a2f374b0cfdef09ab1b69b1281c420.svg";
export { ForwardRef as ReactComponent };